import { AnimatePresence } from 'framer-motion'
import type { CSSProperties } from 'react'
import type { Item } from '../../lib/supabase'
import { SheetPanel } from '../SheetPanel'

// What's in the basket (shopping mode, ux/03 BasketSheet; the phone-basket-sheet
// render): the count over the trip's total, Close, the struck-through rows
// with Put back, then Finish trip.
export function BasketSheet({ open, basket, total, tintFor, zIndex, onPutBack, onFinish, onClose }: {
  open: boolean
  basket: Item[]
  total: number
  tintFor: (categoryId: string | null) => string
  /** Raised over shopping mode. */
  zIndex?: number
  onPutBack: (id: string) => void
  onFinish: () => void
  onClose: () => void
}) {
  return (
    <AnimatePresence>
      {open && (
        <SheetPanel onClose={onClose} ariaLabel="Basket" maxHeight="85dvh" zIndex={zIndex}>
          <div className="ml-basket-sheet__head">
            <div>
              <h2 className="ml-label">Basket</h2>
              <p className="ml-basket-sheet__count ml-num">
                <span className="ml-basket-sheet__n">{basket.length}</span>
                <span className="ml-basket-sheet__total">/{total}</span>
              </p>
            </div>
            <button type="button" className="ml-btn ml-btn--secondary" onClick={onClose}>Close</button>
          </div>
          {basket.length === 0
            ? <p className="ml-caption ml-basket-sheet__empty">Nothing here yet. Flick items in from the list.</p>
            : (
              <ul className="ml-basket-sheet__list">
                {basket.map(item => (
                  <li key={item.id} className="ml-basket-row" style={{ '--ml-tint': tintFor(item.category_id) } as CSSProperties}>
                    <span className="ml-dot" aria-hidden="true" />
                    <span className="ml-basket-row__name">{item.name}</span>
                    <button type="button" className="ml-text-btn" aria-label={`Put back ${item.name}`}
                      onClick={() => onPutBack(item.id)}>
                      Put back
                    </button>
                  </li>
                ))}
              </ul>
            )}
          <button type="button" className="ml-btn ml-btn--primary ml-btn--wide" disabled={basket.length === 0}
            onClick={onFinish}>
            Finish trip
          </button>
          <p className="ml-caption ml-basket-sheet__help">
            Bought items return under Running low when they’re due.
          </p>
        </SheetPanel>
      )}
    </AnimatePresence>
  )
}
